module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/boxoffice/boxoffice-products/boxoffice-products.component.scss
// module id = ./src/app/routes/boxoffice/boxoffice-products/boxoffice-products.component.scss
// module chunks = 9